module.exports = __webpack_public_path__ + "static/media/ARCADE-workshop-6.aefd17bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/neva/ARCADE-workshop-6.jpg
// module id = 342
// module chunks = 0